<h3>{{'ACTION_AND_SPACE_CHOICE.COMPONENT.DATATABLE_TITLE' | translate}}</h3>

<p-table id="actionSpaceChoice" #pdt_action_space_choice (onRowSelect)="handleSelectionOfRow($event.data)"
         [columns]="columns"  [paginator]="true" [paginatorPosition]="'top'" [alwaysShowPaginator]="true" [rows]="DataTableFiller.NUMBER_OF_ROWS_FOR_WORKFLOW_LIST"
         [resizableColumns]="true" [reorderableColumns]="true" [metaKeySelection]="false" selectionMode="single" [selection]="selectedWorkflow"
         [value]="listOfWorkflows" [rowHover]="true">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{ col.header }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-group let-columns="columns">
    <tr [pSelectableRow]="group" [pSelectableRowDisabled]="group.notSelectable">
      <td *ngFor="let column of columns">
        {{ group[ column.field ] }}
      </td>
    </tr>
  </ng-template>
</p-table>

